<template>
  <div>
    <group-banner-create-edit-form isEdit />
  </div>
</template>

<script>
  import GroupBannerCreateEditForm from './components/GroupBannerCreateEditForm.vue';
  export default {
    components: { GroupBannerCreateEditForm },
  };
</script>

<style></style>
